import React, { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Image } from "../../../AbstractElements";
import HeaderCard from "../../Common/HeaderCard";
import { clickAndDrag } from "../../../Constant";
import ScrollBar from "react-perfect-scrollbar";

const ClickAndDrag = () => {
  return (
    <Fragment>
      <Col sm="6">
        <Card>
          <HeaderCard title={clickAndDrag} />
          <CardBody>
            <div className="scroll-bar-wrap">
              <ScrollBar className="click-drag-handler scroll-demo p-0" style={{ width: "100%", height: 300 }}>
                <Image src={require("../../../assets/images/banner/2.jpg")} alt="" width={"100%"} height={"600"} />
              </ScrollBar>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default ClickAndDrag;
